import {
  Columns2,
  Wallet,
  FileText,
  DollarSign,
  CalendarDays,
  UserRound,
  BriefcaseMedical,
  MapPin,
  Building2,
  PiggyBank,
  HeartPulse,
  Stethoscope,
  CreditCard,
  Receipt,
  PieChart,
  Calendar,
  Save,
} from "lucide-react";

/* Paycheck calculator tour content, ported from the mobile "Calculator"
   mockup's paycheck-view steps. Ordered to follow the real page's DOM
   (location card above the salary card) for smooth top-to-bottom scrolling.
   The generic GuidedTour engine renders these; this is just the data. */
export default function getPaycheckTourSteps() {
  return [
    {
      cardSelector: '[data-tour="salary-tabs"]',
      targetSelector: '[data-tour="salary-tabs"]',
      icon: <Columns2 />,
      title: "Two calculators",
      text: "Switch between Hospital union rates and a full Paycheck breakdown.",
    },
    {
      cardSelector: '[data-tour="pc-hero"]',
      targetSelector: '[data-tour="pc-hero"]',
      icon: <Wallet />,
      title: "Your estimated take-home",
      text: "What actually hits your account each payday, with your take-home percentage.",
    },
    {
      cardSelector: '[data-tour="pc-location"]',
      targetSelector: '[data-tour="pc-role"]',
      icon: <BriefcaseMedical />,
      title: "Nursing role",
      text: "Your role tailors the estimate to the right pay data.",
    },
    {
      cardSelector: '[data-tour="pc-location"]',
      targetSelector: '[data-tour="pc-state"]',
      icon: <MapPin />,
      title: "State",
      text: "Your state sets state income tax and insurance.",
    },
    {
      cardSelector: '[data-tour="pc-location"]',
      targetSelector: '[data-tour="pc-city"]',
      icon: <Building2 />,
      title: "City",
      text: "Some cities add a local income tax.",
    },
    {
      cardSelector: '[data-tour="pc-salary"]',
      targetSelector: '[data-tour="pc-paytype"]',
      icon: <FileText />,
      title: "Pay type",
      text: "Enter pay as Hourly or Salary.",
    },
    {
      cardSelector: '[data-tour="pc-salary"]',
      targetSelector: '[data-tour="pc-annual-input"]',
      icon: <DollarSign />,
      title: "Gross pay",
      text: "Your gross pay before taxes and deductions.",
    },
    {
      cardSelector: '[data-tour="pc-salary"]',
      targetSelector: '[data-tour="pc-freq"]',
      icon: <CalendarDays />,
      title: "Pay frequency",
      text: "How often you're paid — weekly, biweekly, monthly.",
    },
    {
      cardSelector: '[data-tour="pc-salary"]',
      targetSelector: '[data-tour="pc-filing"]',
      icon: <UserRound />,
      title: "Filing status",
      text: "Your filing status changes federal withholding.",
    },
    {
      cardSelector: '[data-tour="pc-ded"]',
      targetSelector: '[data-tour="pc-k401"]',
      icon: <PiggyBank />,
      title: "401(k) contribution",
      text: "Pre-tax retirement lowers taxable income.",
    },
    {
      cardSelector: '[data-tour="pc-ded"]',
      targetSelector: '[data-tour="pc-hsa"]',
      icon: <HeartPulse />,
      title: "HSA contribution",
      text: "Pre-tax health savings.",
    },
    {
      cardSelector: '[data-tour="pc-ded"]',
      targetSelector: '[data-tour="pc-health"]',
      icon: <Stethoscope />,
      title: "Health insurance premium",
      text: "Your share of the premium, pre-tax.",
    },
    {
      cardSelector: '[data-tour="pc-ded"]',
      targetSelector: '[data-tour="pc-fsa"]',
      icon: <CreditCard />,
      title: "FSA contribution",
      text: "Pre-tax flexible spending.",
    },
    {
      cardSelector: '[data-tour="pc-breakdown"]',
      targetSelector: '[data-tour="pc-breakdown"]',
      icon: <Receipt />,
      title: "Per paycheck breakdown",
      text: "Every tax and deduction taken from one paycheck.",
    },
    {
      cardSelector: '[data-tour="pc-donut"]',
      targetSelector: '[data-tour="pc-donut"]',
      icon: <PieChart />,
      title: "Where your money goes",
      text: "A visual split of take-home vs each tax.",
    },
    {
      cardSelector: '[data-tour="pc-annual"]',
      targetSelector: '[data-tour="pc-annual"]',
      icon: <Calendar />,
      title: "Annual summary",
      text: "Gross, net, total taxes, and your effective rate for the year.",
    },
    {
      cardSelector: '[data-tour="pc-ctas"]',
      targetSelector: '[data-tour="pc-ctas"]',
      icon: <Save />,
      title: "Save paycheck",
      text: "Save this scenario to revisit later.",
    },
  ];
}
